import React from 'react'
import { Badge, Box, Text, useColorMode } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { getTokens } from '../../config/colorTokens'

const MotionBox = motion(Box)

const TIME_ZONE = 'Asia/Kolkata'
const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri']
const WEEKEND = ['Sat', 'Sun']

const statusRules = [
	{
		days: WEEKDAYS,
		start: 7,
		end: 10,
		label: 'Morning routine, light replies',
		color: '#06B6D4'
	},
	{
		days: WEEKDAYS,
		start: 10,
		end: 20,
		label: 'Building at Wells Fargo',
		color: '#3B82F6'
	},
	{
		days: WEEKDAYS,
		start: 20,
		end: 22,
		label: 'Dinner, family time',
		color: '#10B981'
	},
	{
		days: WEEKDAYS,
		start: 22,
		end: 24,
		label: 'Studying, building, exploring',
		color: '#F59E0B'
	},
	{
		days: WEEKDAYS,
		start: 0,
		end: 7,
		label: 'Offline, replies a little later',
		color: '#71717A'
	},
	{
		days: WEEKEND,
		start: 10,
		end: 18,
		label: 'Open to collaborations',
		color: '#10B981'
	},
	{
		days: WEEKEND,
		start: 18,
		end: 24,
		label: 'Experimenting with weekend builds',
		color: '#8B5CF6'
	},
	{
		days: WEEKEND,
		start: 0,
		end: 10,
		label: 'Slow morning, async-first',
		color: '#71717A'
	}
]

const getTimeParts = (date) => {
	const parts = new Intl.DateTimeFormat('en-US', {
		timeZone: TIME_ZONE,
		weekday: 'short',
		hour: 'numeric',
		hour12: false,
		hourCycle: 'h23'
	}).formatToParts(date)

	return {
		weekday: parts.find((part) => part.type === 'weekday')?.value,
		hour: Number(parts.find((part) => part.type === 'hour')?.value)
	}
}

const getAvailabilityStatus = (date = new Date()) => {
	const { weekday, hour } = getTimeParts(date)

	return (
		statusRules.find((rule) => rule.days.includes(weekday) && hour >= rule.start && hour < rule.end) ||
		statusRules[0]
	)
}

const AvailabilityStatus = () => {
	const { colorMode } = useColorMode()
	const t = getTokens(colorMode)
	const [status, setStatus] = React.useState(getAvailabilityStatus)

	React.useEffect(() => {
		const intervalId = setInterval(() => {
			setStatus(getAvailabilityStatus())
		}, 60000)

		return () => clearInterval(intervalId)
	}, [])

	return (
		<Box
			as="section"
			aria-label="Live availability status"
			maxW="min(92vw, 42rem)"
			mt={1}
			mb={2}>
			<Badge
				display="inline-flex"
				alignItems="center"
				gap={2}
				px={3}
				py={1.5}
				borderRadius="full"
				textTransform="none"
				fontSize={{ base: '0.72rem', md: '0.78rem' }}
				fontWeight="medium"
				letterSpacing="0"
				color={t.textSecondary}
				bg={t.surfaceAlpha}
				border="1px solid"
				borderColor={t.borderSubtle}
				// boxShadow={`0 12px 32px ${status.color}`}
				// boxShadow={`0 0 0 4px ${status.color}24`}
				>
				<MotionBox
					aria-hidden="true"
					w="0.48rem"
					h="0.48rem"
					borderRadius="full"
					bg={status.color}
					boxShadow={`0 0 0 4px ${status.color}24`}
					animate={{ opacity: [0.6, 1, 0.6], scale: [1, 1.12, 1] }}
					transition={{ duration: 2.2, repeat: Infinity, ease: 'easeInOut' }}
				/>
				<Text as="span" color={t.textPrimary}>
					{status.label}
				</Text>
			</Badge>
		</Box>
	)
}

export default AvailabilityStatus
